




import { Component, Vue, Prop } from "vue-property-decorator";
import Fullscreen from "vue-fullscreen";
Vue.use(Fullscreen, { name: "fs" });

import { BIconArrowsFullscreen, BIconArrowRepeat } from "bootstrap-vue";

import { RevolvaService } from "./revolva.service";
import * as actions from "./revolva.action";
import productsInfoJson from "@/assets/productsInfo.json";
import productsListJson from "@/assets/productsList.json";
import piecesInfoJson from "@/assets/piecesInfo.json";

interface Dictionary<T> {
  [Key: string]: T;
}

interface FullscreenComponent extends Element {
  getState(): boolean;
  toggle(): void;
}

@Component({
  components: { BIconArrowsFullscreen, BIconArrowRepeat },
})
export default class Model3D extends Vue {
  @Prop() readonly revolva: RevolvaService | undefined;
  @Prop() onLoaded: Function;

  public Canvafullscreen: false;
  public fullscreen: false;
  public CanvaStatusfullscreen = false;

  public canvasH = 0;
  public canvasW = 0;
  public offsetHeight = 60;
  public offsetWidth = 0;

  public loading3d = true;

  mounted() {
    this.Canvafullscreen = false;
    this.loading3d = this.revolva.loading3D;
    actions.setCanvas(this.revolva, document.getElementById("canvas") as HTMLCanvasElement);
    actions.setMainObjects(this.revolva);
    actions.init(this.revolva);
    actions.setproductsListJson(this.revolva, productsListJson);
    actions.setProductsInfo(this.revolva, productsInfoJson);
    actions.setPiecesInfo(this.revolva, piecesInfoJson);
    actions.startLoad3d(this.revolva).then(() => {
      this.onLoaded();
    });
  }

  created() {
    window.addEventListener("resize", this.onWindowResize, false);
  }
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  }
  
  onWindowResize() {
    console.warn("Resize !!!")
    actions.renderModel(this.revolva);
  }

  public toggle() {
    (this.$refs.fullscreen as FullscreenComponent).toggle();
  }

  fullscreenChange(fullscreen: boolean) {
    actions.setCanvafullScreen(this.revolva, fullscreen);
    actions.renderModel(this.revolva);

    this.CanvaStatusfullscreen = fullscreen;
  }

  public animate() {
    this.revolva.animation = !this.revolva.animation;
    actions.renderModel(this.revolva);
  }
}
